export const UUI_PRESETS_PANEL_ADD_BUTTON = 'uui-presets-panel-add-button';
export const UUI_PRESETS_PANEL_MORE_BUTTON = 'uui-presets-panel-more-button';
export const UUI_PRESETS_PANEL_INPUT = 'uui-presets-panel-input';
export const UUI_PRESETS_PANEL_PRESET = 'uui-presets-panel-preset';
